import React from "react";
import Card from "components/card";

function DeviceDetails({ deviceDetails }) {
  return (
    <Card extra="rounded-[20px] p-3 relative">
      <div className="flex flex-row justify-between px-3 pt-2">
        <div>
          <h4 className="mb-3 text-lg font-bold text-navy-700 dark:text-white">
            {deviceDetails.displayName}
          </h4>
        </div>
      </div>
      <div className="mb-4">
        <img src={deviceDetails.AssetImg} alt="Asset" />
      </div>

      <div className="ml-4 flex flex-col w-auto space-y-2">
        {deviceDetails.deviceDetailsTable.map((data, index) => {
          // Extract the key and value from each object
          const [key, value] = Object.entries(data)[0];
          return (
            <div key={index} className="flex flex-row">
              <p className="mr-2 font-dm text-sm font-medium text-navy-700 dark:text-white">{key}:</p>
              <p className="font-dm text-sm font-medium text-navy-700 dark:text-white">{value}</p>
            </div>
          );
        })}
      </div>
    </Card>
  );
}

export default React.memo(DeviceDetails);
